export const labelPositions = (pos, imgWidth = 0) => {
  const positions = {
    0: { left: 0, top: 0 },
    1: { right: `${50 - imgWidth / 2}%`, top: 0 },
    2: { right: 0, top: 0 },
    3: { left: 0, top: `${50 - imgWidth / 2}%` },
    4: { right: `${50 - imgWidth / 2}%`, top: `${50 - imgWidth / 2}%` },
    5: { right: 0, top: `${50 - imgWidth / 2}%` },
    6: { left: 0, top: `${100 - imgWidth}%` },
    7: { right: `${50 - imgWidth / 2}%`, top: `${100 - imgWidth}%` },
    8: { right: 0, top: `${100 - imgWidth}%` },
  };

  return positions?.[pos];
};

export const genderOptions = [
  { value: 'male', 'label-en': 'Male', 'label-ar': 'ذكر' },
  { value: 'female', 'label-en': 'Female', 'label-ar': 'أنثى' },
];

export const maritalStatusOptions = [
  { value: 'single', 'label-en': 'Single', 'label-ar': 'أعزب / عزباء' },
  { value: 'married', 'label-en': 'Married', 'label-ar': 'متزوج / متزوجة' },
  { value: 'divorced', 'label-en': 'Divorced', 'label-ar': 'مطلق / مطلقة' },
  { value: 'widowed', 'label-en': 'Widowed', 'label-ar': 'أرمل / أرملة' },
];

export const workSectorOptions = [
  { value: 'education', 'label-en': 'Education', 'label-ar': 'التعليم' },
  {
    value: 'healthcare',
    'label-en': 'Healthcare',
    'label-ar': 'الرعاية الصحية',
  },
  { value: 'finance', 'label-en': 'Finance', 'label-ar': 'المالية' },
  { value: 'technology', 'label-en': 'Technology', 'label-ar': 'التكنولوجيا' },
  { value: 'government', 'label-en': 'Government', 'label-ar': 'الحكومة' },
  { value: 'retail', 'label-en': 'Retail', 'label-ar': 'التجزئة' },
  {
    value: 'manufacturing',
    'label-en': 'Manufacturing',
    'label-ar': 'التصنيع',
  },
  { value: 'other', 'label-en': 'Other', 'label-ar': 'آخر' },
];

export const countryOptions = [
  {
    value: 'sa',
    'label-en': 'Saudi Arabia',
    'label-ar': 'المملكة العربية السعودية',
  },
  {
    value: 'ae',
    'label-en': 'United Arab Emirates',
    'label-ar': 'الإمارات العربية المتحدة',
  },
  { value: 'eg', 'label-en': 'Egypt', 'label-ar': 'مصر' },
  { value: 'kw', 'label-en': 'Kuwait', 'label-ar': 'الكويت' },
  { value: 'qa', 'label-en': 'Qatar', 'label-ar': 'قطر' },
  { value: 'bh', 'label-en': 'Bahrain', 'label-ar': 'البحرين' },
  { value: 'om', 'label-en': 'Oman', 'label-ar': 'عُمان' },
  { value: 'jo', 'label-en': 'Jordan', 'label-ar': 'الأردن' },
  { value: 'lb', 'label-en': 'Lebanon', 'label-ar': 'لبنان' },
  { value: 'ma', 'label-en': 'Morocco', 'label-ar': 'المغرب' },
  { value: 'tn', 'label-en': 'Tunisia', 'label-ar': 'تونس' },
  { value: 'dz', 'label-en': 'Algeria', 'label-ar': 'الجزائر' },
  { value: 'iq', 'label-en': 'Iraq', 'label-ar': 'العراق' },
  { value: 'sy', 'label-en': 'Syria', 'label-ar': 'سوريا' },
  { value: 'ye', 'label-en': 'Yemen', 'label-ar': 'اليمن' },
  { value: 'ps', 'label-en': 'Palestine', 'label-ar': 'فلسطين' },
  { value: 'sd', 'label-en': 'Sudan', 'label-ar': 'السودان' },
  { value: 'ly', 'label-en': 'Libya', 'label-ar': 'ليبيا' },
  { value: 'mr', 'label-en': 'Mauritania', 'label-ar': 'موريتانيا' },
  { value: 'so', 'label-en': 'Somalia', 'label-ar': 'الصومال' },
  { value: 'dj', 'label-en': 'Djibouti', 'label-ar': 'جيبوتي' },
  { value: 'km', 'label-en': 'Comoros', 'label-ar': 'جزر القمر' },
  { value: 'af', 'label-en': 'Afghanistan', 'label-ar': 'أفغانستان' },
  { value: 'al', 'label-en': 'Albania', 'label-ar': 'ألبانيا' },
  { value: 'ad', 'label-en': 'Andorra', 'label-ar': 'أندورا' },
  { value: 'ao', 'label-en': 'Angola', 'label-ar': 'أنغولا' },
  {
    value: 'ag',
    'label-en': 'Antigua and Barbuda',
    'label-ar': 'أنتيغوا وباربودا',
  },
  { value: 'ar', 'label-en': 'Argentina', 'label-ar': 'الأرجنتين' },
  { value: 'am', 'label-en': 'Armenia', 'label-ar': 'أرمينيا' },
  { value: 'au', 'label-en': 'Australia', 'label-ar': 'أستراليا' },
  { value: 'at', 'label-en': 'Austria', 'label-ar': 'النمسا' },
  { value: 'az', 'label-en': 'Azerbaijan', 'label-ar': 'أذربيجان' },
  { value: 'bs', 'label-en': 'Bahamas', 'label-ar': 'باهاماس' },
  { value: 'bd', 'label-en': 'Bangladesh', 'label-ar': 'بنغلاديش' },
  { value: 'bb', 'label-en': 'Barbados', 'label-ar': 'باربادوس' },
  { value: 'by', 'label-en': 'Belarus', 'label-ar': 'بيلاروسيا' },
  { value: 'be', 'label-en': 'Belgium', 'label-ar': 'بلجيكا' },
  { value: 'bz', 'label-en': 'Belize', 'label-ar': 'بليز' },
  { value: 'bj', 'label-en': 'Benin', 'label-ar': 'بنين' },
  { value: 'bt', 'label-en': 'Bhutan', 'label-ar': 'بوتان' },
  { value: 'bo', 'label-en': 'Bolivia', 'label-ar': 'بوليفيا' },
  {
    value: 'ba',
    'label-en': 'Bosnia and Herzegovina',
    'label-ar': 'البوسنة والهرسك',
  },
  { value: 'bw', 'label-en': 'Botswana', 'label-ar': 'بوتسوانا' },
  { value: 'br', 'label-en': 'Brazil', 'label-ar': 'البرازيل' },
  { value: 'bn', 'label-en': 'Brunei', 'label-ar': 'بروناي' },
  { value: 'bg', 'label-en': 'Bulgaria', 'label-ar': 'بلغاريا' },
  { value: 'bf', 'label-en': 'Burkina Faso', 'label-ar': 'بوركينا فاسو' },
  { value: 'bi', 'label-en': 'Burundi', 'label-ar': 'بوروندي' },
  { value: 'cv', 'label-en': 'Cabo Verde', 'label-ar': 'الرأس الأخضر' },
  { value: 'kh', 'label-en': 'Cambodia', 'label-ar': 'كمبوديا' },
  { value: 'cm', 'label-en': 'Cameroon', 'label-ar': 'الكاميرون' },
  { value: 'ca', 'label-en': 'Canada', 'label-ar': 'كندا' },
  {
    value: 'cf',
    'label-en': 'Central African Republic',
    'label-ar': 'جمهورية أفريقيا الوسطى',
  },
  { value: 'td', 'label-en': 'Chad', 'label-ar': 'تشاد' },
  { value: 'cl', 'label-en': 'Chile', 'label-ar': 'تشيلي' },
  { value: 'cn', 'label-en': 'China', 'label-ar': 'الصين' },
  { value: 'co', 'label-en': 'Colombia', 'label-ar': 'كولومبيا' },
  { value: 'km', 'label-en': 'Comoros', 'label-ar': 'جزر القمر' },
  {
    value: 'cd',
    'label-en': 'Congo (Democratic Republic)',
    'label-ar': 'جمهورية الكونغو الديمقراطية',
  },
  {
    value: 'cg',
    'label-en': 'Congo (Republic)',
    'label-ar': 'جمهورية الكونغو',
  },
  { value: 'cr', 'label-en': 'Costa Rica', 'label-ar': 'كوستاريكا' },
  { value: 'ci', 'label-en': "Côte d'Ivoire", 'label-ar': 'ساحل العاج' },
  { value: 'hr', 'label-en': 'Croatia', 'label-ar': 'كرواتيا' },
  { value: 'cu', 'label-en': 'Cuba', 'label-ar': 'كوبا' },
  { value: 'cy', 'label-en': 'Cyprus', 'label-ar': 'قبرص' },
  { value: 'cz', 'label-en': 'Czech Republic', 'label-ar': 'جمهورية التشيك' },
  { value: 'dk', 'label-en': 'Denmark', 'label-ar': 'الدنمارك' },
  { value: 'dj', 'label-en': 'Djibouti', 'label-ar': 'جيبوتي' },
  { value: 'dm', 'label-en': 'Dominica', 'label-ar': 'دومينيكا' },
  {
    value: 'do',
    'label-en': 'Dominican Republic',
    'label-ar': 'جمهورية الدومينيكان',
  },
  { value: 'ec', 'label-en': 'Ecuador', 'label-ar': 'الإكوادور' },
  { value: 'sv', 'label-en': 'El Salvador', 'label-ar': 'السلفادور' },
  {
    value: 'gq',
    'label-en': 'Equatorial Guinea',
    'label-ar': 'غينيا الاستوائية',
  },
  { value: 'er', 'label-en': 'Eritrea', 'label-ar': 'إريتريا' },
  { value: 'ee', 'label-en': 'Estonia', 'label-ar': 'إستونيا' },
  { value: 'sz', 'label-en': 'Eswatini', 'label-ar': 'إسواتيني' },
  { value: 'et', 'label-en': 'Ethiopia', 'label-ar': 'إثيوبيا' },
  { value: 'fj', 'label-en': 'Fiji', 'label-ar': 'فيجي' },
  { value: 'fi', 'label-en': 'Finland', 'label-ar': 'فنلندا' },
  { value: 'fr', 'label-en': 'France', 'label-ar': 'فرنسا' },
  { value: 'ga', 'label-en': 'Gabon', 'label-ar': 'الغابون' },
  { value: 'gm', 'label-en': 'Gambia', 'label-ar': 'غامبيا' },
  { value: 'ge', 'label-en': 'Georgia', 'label-ar': 'جورجيا' },
  { value: 'de', 'label-en': 'Germany', 'label-ar': 'ألمانيا' },
  { value: 'gh', 'label-en': 'Ghana', 'label-ar': 'غانا' },
  { value: 'gr', 'label-en': 'Greece', 'label-ar': 'اليونان' },
  { value: 'gd', 'label-en': 'Grenada', 'label-ar': 'غرينادا' },
  { value: 'gt', 'label-en': 'Guatemala', 'label-ar': 'غواتيمالا' },
  { value: 'gn', 'label-en': 'Guinea', 'label-ar': 'غينيا' },
  { value: 'gw', 'label-en': 'Guinea-Bissau', 'label-ar': 'غينيا بيساو' },
  { value: 'gy', 'label-en': 'Guyana', 'label-ar': 'غيانا' },
  { value: 'ht', 'label-en': 'Haiti', 'label-ar': 'هايتي' },
  { value: 'hn', 'label-en': 'Honduras', 'label-ar': 'هندوراس' },
  { value: 'hu', 'label-en': 'Hungary', 'label-ar': 'المجر' },
  { value: 'is', 'label-en': 'Iceland', 'label-ar': 'آيسلندا' },
  { value: 'in', 'label-en': 'India', 'label-ar': 'الهند' },
  { value: 'id', 'label-en': 'Indonesia', 'label-ar': 'إندونيسيا' },
  { value: 'ir', 'label-en': 'Iran', 'label-ar': 'إيران' },
  { value: 'ie', 'label-en': 'Ireland', 'label-ar': 'أيرلندا' },
  { value: 'it', 'label-en': 'Italy', 'label-ar': 'إيطاليا' },
  { value: 'jm', 'label-en': 'Jamaica', 'label-ar': 'جامايكا' },
  { value: 'jp', 'label-en': 'Japan', 'label-ar': 'اليابان' },
  { value: 'kz', 'label-en': 'Kazakhstan', 'label-ar': 'كازاخستان' },
  { value: 'ke', 'label-en': 'Kenya', 'label-ar': 'كينيا' },
  { value: 'ki', 'label-en': 'Kiribati', 'label-ar': 'كيريباتي' },
  { value: 'kp', 'label-en': 'Korea (North)', 'label-ar': 'كوريا الشمالية' },
  { value: 'kr', 'label-en': 'Korea (South)', 'label-ar': 'كوريا الجنوبية' },
  { value: 'xk', 'label-en': 'Kosovo', 'label-ar': 'كوسوفو' },
  { value: 'kg', 'label-en': 'Kyrgyzstan', 'label-ar': 'قيرغيزستان' },
  { value: 'la', 'label-en': 'Laos', 'label-ar': 'لاوس' },
  { value: 'lv', 'label-en': 'Latvia', 'label-ar': 'لاتفيا' },
  { value: 'ls', 'label-en': 'Lesotho', 'label-ar': 'ليسوتو' },
  { value: 'lr', 'label-en': 'Liberia', 'label-ar': 'ليبيريا' },
  { value: 'li', 'label-en': 'Liechtenstein', 'label-ar': 'ليختنشتاين' },
  { value: 'lt', 'label-en': 'Lithuania', 'label-ar': 'ليتوانيا' },
  { value: 'lu', 'label-en': 'Luxembourg', 'label-ar': 'لوكسمبورغ' },
  { value: 'mg', 'label-en': 'Madagascar', 'label-ar': 'مدغشقر' },
  { value: 'mw', 'label-en': 'Malawi', 'label-ar': 'ملاوي' },
  { value: 'my', 'label-en': 'Malaysia', 'label-ar': 'ماليزيا' },
  { value: 'mv', 'label-en': 'Maldives', 'label-ar': 'جزر المالديف' },
  { value: 'ml', 'label-en': 'Mali', 'label-ar': 'مالي' },
  { value: 'mt', 'label-en': 'Malta', 'label-ar': 'مالطا' },
  { value: 'mh', 'label-en': 'Marshall Islands', 'label-ar': 'جزر مارشال' },
  { value: 'mu', 'label-en': 'Mauritius', 'label-ar': 'موريشيوس' },
  { value: 'mx', 'label-en': 'Mexico', 'label-ar': 'المكسيك' },
  { value: 'fm', 'label-en': 'Micronesia', 'label-ar': 'مايكرونيزيا' },
  { value: 'md', 'label-en': 'Moldova', 'label-ar': 'مولدوفا' },
  { value: 'mc', 'label-en': 'Monaco', 'label-ar': 'موناكو' },
  { value: 'mn', 'label-en': 'Mongolia', 'label-ar': 'منغوليا' },
  { value: 'me', 'label-en': 'Montenegro', 'label-ar': 'الجبل الأسود' },
  { value: 'mz', 'label-en': 'Mozambique', 'label-ar': 'موزمبيق' },
  { value: 'mm', 'label-en': 'Myanmar', 'label-ar': 'ميانمار' },
  { value: 'na', 'label-en': 'Namibia', 'label-ar': 'ناميبيا' },
  { value: 'nr', 'label-en': 'Nauru', 'label-ar': 'ناورو' },
  { value: 'np', 'label-en': 'Nepal', 'label-ar': 'نيبال' },
  { value: 'nl', 'label-en': 'Netherlands', 'label-ar': 'هولندا' },
  { value: 'nz', 'label-en': 'New Zealand', 'label-ar': 'نيوزيلندا' },
  { value: 'ni', 'label-en': 'Nicaragua', 'label-ar': 'نيكاراغوا' },
  { value: 'ne', 'label-en': 'Niger', 'label-ar': 'النيجر' },
  { value: 'ng', 'label-en': 'Nigeria', 'label-ar': 'نيجيريا' },
  {
    value: 'mk',
    'label-en': 'North Macedonia',
    'label-ar': 'مقدونيا الشمالية',
  },
  { value: 'no', 'label-en': 'Norway', 'label-ar': 'النرويج' },
  { value: 'pk', 'label-en': 'Pakistan', 'label-ar': 'باكستان' },
  { value: 'pw', 'label-en': 'Palau', 'label-ar': 'بالاو' },
  { value: 'pa', 'label-en': 'Panama', 'label-ar': 'بنما' },
  {
    value: 'pg',
    'label-en': 'Papua New Guinea',
    'label-ar': 'بابوا غينيا الجديدة',
  },
  { value: 'py', 'label-en': 'Paraguay', 'label-ar': 'باراغواي' },
  { value: 'pe', 'label-en': 'Peru', 'label-ar': 'بيرو' },
  { value: 'ph', 'label-en': 'Philippines', 'label-ar': 'الفلبين' },
  { value: 'pl', 'label-en': 'Poland', 'label-ar': 'بولندا' },
  { value: 'pt', 'label-en': 'Portugal', 'label-ar': 'البرتغال' },
  { value: 'ro', 'label-en': 'Romania', 'label-ar': 'رومانيا' },
  { value: 'ru', 'label-en': 'Russia', 'label-ar': 'روسيا' },
  { value: 'rw', 'label-en': 'Rwanda', 'label-ar': 'رواندا' },
  {
    value: 'kn',
    'label-en': 'Saint Kitts and Nevis',
    'label-ar': 'سانت كيتس ونيفيس',
  },
  { value: 'lc', 'label-en': 'Saint Lucia', 'label-ar': 'سانت لوسيا' },
  {
    value: 'vc',
    'label-en': 'Saint Vincent and the Grenadines',
    'label-ar': 'سانت فنسنت والغرينادين',
  },
  { value: 'ws', 'label-en': 'Samoa', 'label-ar': 'ساموا' },
  { value: 'sm', 'label-en': 'San Marino', 'label-ar': 'سان مارينو' },
  {
    value: 'st',
    'label-en': 'Sao Tome and Principe',
    'label-ar': 'ساو تومي وبرينسيبي',
  },
  { value: 'sn', 'label-en': 'Senegal', 'label-ar': 'السنغال' },
  { value: 'rs', 'label-en': 'Serbia', 'label-ar': 'صربيا' },
  { value: 'sc', 'label-en': 'Seychelles', 'label-ar': 'سيشل' },
  { value: 'sl', 'label-en': 'Sierra Leone', 'label-ar': 'سيراليون' },
  { value: 'sg', 'label-en': 'Singapore', 'label-ar': 'سنغافورة' },
  { value: 'sk', 'label-en': 'Slovakia', 'label-ar': 'سلوفاكيا' },
  { value: 'si', 'label-en': 'Slovenia', 'label-ar': 'سلوفينيا' },
  { value: 'sb', 'label-en': 'Solomon Islands', 'label-ar': 'جزر سليمان' },
  { value: 'za', 'label-en': 'South Africa', 'label-ar': 'جنوب أفريقيا' },
  { value: 'ss', 'label-en': 'South Sudan', 'label-ar': 'جنوب السودان' },
  { value: 'es', 'label-en': 'Spain', 'label-ar': 'إسبانيا' },
  { value: 'lk', 'label-en': 'Sri Lanka', 'label-ar': 'سريلانكا' },
  { value: 'sr', 'label-en': 'Suriname', 'label-ar': 'سورينام' },
  { value: 'se', 'label-en': 'Sweden', 'label-ar': 'السويد' },
  { value: 'ch', 'label-en': 'Switzerland', 'label-ar': 'سويسرا' },
  { value: 'tw', 'label-en': 'Taiwan', 'label-ar': 'تايوان' },
  { value: 'tj', 'label-en': 'Tajikistan', 'label-ar': 'طاجيكستان' },
  { value: 'tz', 'label-en': 'Tanzania', 'label-ar': 'تنزانيا' },
  { value: 'th', 'label-en': 'Thailand', 'label-ar': 'تايلاند' },
  { value: 'tl', 'label-en': 'Timor-Leste', 'label-ar': 'تيمور الشرقية' },
  { value: 'tg', 'label-en': 'Togo', 'label-ar': 'توغو' },
  { value: 'to', 'label-en': 'Tonga', 'label-ar': 'تونغا' },
  {
    value: 'tt',
    'label-en': 'Trinidad and Tobago',
    'label-ar': 'ترينيداد وتوباغو',
  },
  { value: 'tn', 'label-en': 'Tunisia', 'label-ar': 'تونس' },
  { value: 'tr', 'label-en': 'Turkey', 'label-ar': 'تركيا' },
  { value: 'tm', 'label-en': 'Turkmenistan', 'label-ar': 'تركمانستان' },
  { value: 'tv', 'label-en': 'Tuvalu', 'label-ar': 'توفالو' },
  { value: 'ug', 'label-en': 'Uganda', 'label-ar': 'أوغندا' },
  { value: 'ua', 'label-en': 'Ukraine', 'label-ar': 'أوكرانيا' },
  { value: 'gb', 'label-en': 'United Kingdom', 'label-ar': 'المملكة المتحدة' },
  { value: 'us', 'label-en': 'United States', 'label-ar': 'الولايات المتحدة' },
  { value: 'uy', 'label-en': 'Uruguay', 'label-ar': 'أوروغواي' },
  { value: 'uz', 'label-en': 'Uzbekistan', 'label-ar': 'أوزبكستان' },
  { value: 'vu', 'label-en': 'Vanuatu', 'label-ar': 'فانواتو' },
  { value: 'va', 'label-en': 'Vatican City', 'label-ar': 'الفاتيكان' },
  { value: 've', 'label-en': 'Venezuela', 'label-ar': 'فنزويلا' },
  { value: 'vn', 'label-en': 'Vietnam', 'label-ar': 'فيتنام' },
  { value: 'eh', 'label-en': 'Western Sahara', 'label-ar': 'الصحراء الغربية' },
  { value: 'zm', 'label-en': 'Zambia', 'label-ar': 'زامبيا' },
  { value: 'zw', 'label-en': 'Zimbabwe', 'label-ar': 'زيمبابوي' },
];

export const modifyCss = (cssString) => {
  const style = {};

  cssString.split(';').forEach((rule) => {
    const [property, value] = rule.split(':').map((item) => item.trim());
    if (property && value) {
      const reactProperty = property
        .replace(/-([a-z])/g, (g) => g[1].toUpperCase())
        .replace('!important', '');

      style[reactProperty] = value.replace('!important', '').trim();
    }
  });

  return style;
};
